export const redText = (str: string) => `<span>${str}</span>`;
